import * as ng from 'angular';

const globalConfig = require('./global.val');

// load config json into constant for easy injecting
let config = JSON.parse(document.getElementById('config').innerText);
ng.extend(config, globalConfig);

const app = ng.module('selfReg');
app.constant('config', config);
